var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWachtwoordIcoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#BEBEBE",
    width: 25.379,
    height: 32,
    viewBox: "0 0 25.379 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Wachtwoord_Icoon",
    "data-name": "Wachtwoord Icoon",
    d: "M6.427,35.856V18.2h3.31V12.684a8.827,8.827,0,0,1,8.828-8.828h1.1A8.828,8.828,0,0,1,28.5,12.684V18.2h3.31V35.856H6.427Zm11.855-9.063-.821,5.752h3.31l-.822-5.752a2.206,2.206,0,1,0-1.667,0Zm6.9-13.558a6.069,6.069,0,0,0-12.138,0V18.2H25.185Z",
    transform: "translate(-6.427 -3.856)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWachtwoordIcoon);
export default __webpack_public_path__ + "static/media/Wachtwoord-Icoon.b193c4df.svg";
export { ForwardRef as ReactComponent };